import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Alert,
    Container,
    Header as HeaderRS,
    Content,
    Footer,
    Sidebar as Side } from 'rsuite';
import { Header,
    Form,
    Button,
    Segment,
    Icon,
    Dropdown,
    Divider,
    List } from 'semantic-ui-react';
import { api } from '../../../services/api';


import Navbarr from '../../../components/Navbar';

import './styles.css';

export default function OwnProductViewEdit ({ sidebar: Sidebar}) {
    const { id } = useParams();
    const [prodStates, setProdStates] = useState({
        prod: {},
        formProd: {
            id: '',
            nome: '',
            lojas: [],
            competidores: []
        },
        stores: [],
        storeOptions: [],
        currentStores: [],
        compt: [],
        comptOptions: [],
        currentCompt: [],
        isLoadingData: true,
        isEditing: false
    });

    async function handleStorCompt() {
        await handleStores();
        await handleCompt();
    }

    async function handleStores() {
        const currentStores = [];
        const storesOptions = [];
        const stores = await fetchStores();
        stores.forEach(
            stor => {
                storesOptions.push({key: stor['id'],
                                    text: stor['nome'],
                                    value: stor['id']});
            }
        );

        prodStates['prod']['lojas'].forEach(
            stor => {
                currentStores.push(stor['id']);
            }
        );

        handleStoreChange(null, {value: currentStores});

        setProdStates(prevState => ({
            ...prevState,
            stores: stores,
            storesOptions: storesOptions,
        }));
    }

    async function handleCompt() {
        const currentCompt = [];
        const comptOptions = [];
        const compt = await fetchCompt();
        compt.forEach(
            cp => {
                comptOptions.push({key: cp['id'],
                                    text: cp['nome'],
                                    value: cp['id']});
            }
        );

        prodStates['prod']['competidores'].forEach(
            cp => {
                currentCompt.push(cp['id']);
            }
        );

        handleComptChange(null, {value: currentCompt});
        setProdStates(prevState => ({
            ...prevState,
            compt: compt,
            comptOptions: comptOptions,
        }));
    }

    async function fetchStores() {
        try {
            const data = await api.getStores();
            return data;
        } catch (err) {
            console.error("Falha ao obter lojas: ", err);
        }
    }

    async function fetchCompt() {
        try {
            const data = await api.getCompProducts();
            return data;
        } catch (err) {
            console.error("Falha ao obter competidores: ", err);
        }
    }

    const handleNomeChange = (e, {value}) => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: {
                ...prevState['formProd'],
                nome: value
            }
        }));
    }

    const handleStoreChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            currentStores: value
        }));
    }

    const handleComptChange = (e, {value}) => {
        setProdStates((prevState) => ({
            ...prevState,
            currentCompt: value
        }));
    }

    async function editProd () {
        setProdStates(prevState => ({
            ...prevState,
            isLoadingData: true
        }));

        await handleStorCompt();

        setProdStates(prevState => ({
            ...prevState,
            isEditing: true,
            isLoadingData: false,
        }));
    }

    const cancelProdEdit = () => {
        setProdStates( prevState => ({
            ...prevState,
            formProd: prevState['prod'],
            isEditing: false
            }
        ));
    }

    async function handlePut() {
        try {

            setProdStates( prevState => ({
                ...prevState,
                isLoading: true,
            }));

            const competidores = [];
            const lojas = [];

            prodStates['currentCompt'].forEach(
                cp => competidores.push({'id':cp})
            );

            prodStates['currentStores'].forEach(
                loja => lojas.push({'id':loja})
            );

            const data = await api.putOwnProduct(prodStates['formProd']['id'],
                                            prodStates['formProd']['nome'],
                                            competidores, lojas);
            setProdStates( prevState => ({
                ...prevState,
                prod: data,
                formProd: {
                    ...prevState['formProd'],
                    ...data
                },
                isLoadingData: false,
                isEditing: false
            }));
            Alert.success('Produto atualizado com sucesso!');
        } catch (err) {
            Alert.error('Falha ao atualizar produto.');
            console.error('Falha ao atualizar produto: ', err);
            setProdStates( prevState => ({
                ...prevState,
                isLoadingData: false,
                isEditing: true
            }));
        }
    }

    useEffect(() => {
        async function fetchProd() {
            try {
                const data = await api.getOwnProductById(id);
                setProdStates( prevState => ({
                    ...prevState,
                    prod: data,
                    formProd: {
                        ...prevState['formProd'],
                        ...data
                    },
                    isLoadingData: false
                }));
            } catch (err) {
                console.error("Falha ao obter produto: ", err);
            }
        }

        fetchProd();
    },[id]);


    return (
        <Container>
            <Side style={{ flex: '0 0 auto', width: 'auto' }}>
                <Sidebar page={"productlist"}></Sidebar>
            </Side>
            <Container>
                <HeaderRS>
                    <Navbarr></Navbarr>
                </HeaderRS>
                <Content style={{ backgroundColor: '#FAFAFA', padding: '5px'}}>
                    <div>
                        <Segment
                            loading={prodStates['isLoadingData']}
                            style={{ boxShadow: '0 0 0 0 rgba(255, 255, 255, 0)' }}
                            >
                            <Header as='h3' floated='left'>
                                Informações do Produto
                            </Header>
                            {!prodStates['isEditing'] && <Button
                                primary
                                size="mini"
                                floated='right'
                                onClick={editProd}
                                >
                                    <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                        <Icon name='edit'/> Editar
                                    </div>
                            </Button>}

                            <Divider clearing />
                            <Form>
                                <Form.Group inline>
                                    </Form.Group>
                                    <Form.Group widths='equal'>
                                        <Form.Input
                                            readOnly={true}
                                            iconPosition='left'
                                            icon='key'
                                            fluid label='Identificador'
                                            placeholder='Identificador'
                                            value={prodStates['formProd'] ? prodStates['formProd']['id']: ""}
                                            />

                                        <Form.Input
                                            readOnly={!prodStates['isEditing']}
                                            iconPosition='left'
                                            icon='coffee'
                                            fluid label='Nome'
                                            placeholder='Nome'
                                            value={prodStates['formProd'] ? prodStates['formProd']['nome']: ""}
                                            onChange={handleNomeChange}
                                        />
                                    </Form.Group>

                                    {/* Dropdown competidores*/}
                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Competidores</label>
                                        </Form.Group>
                                    }
                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!prodStates['isEditing']}
                                                options={prodStates['comptOptions']}
                                                placeholder='Escolha competidores'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={prodStates['currentCompt']}
                                                onChange={handleComptChange}
                                            />
                                        </Form.Group>
                                    }

                                    {/* Dropdown lojas*/}
                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline style={{marginBottom: '4px'}}>
                                            <label>Lojas</label>
                                        </Form.Group>
                                    }

                                    {prodStates['formProd'] && prodStates['isEditing'] &&
                                        <Form.Group inline>
                                            <Dropdown
                                                disabled={!prodStates['isEditing']}
                                                options={prodStates['storesOptions']}
                                                placeholder='Escolha lojas'
                                                search
                                                selection
                                                fluid
                                                multiple
                                                value={prodStates['currentStores']}
                                                onChange={handleStoreChange}
                                            />
                                        </Form.Group>
                                    }

                                    {prodStates['formProd'] && !prodStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Competidores
                                            </Header.Content>
                                        </Header>
                                    }
                                    {prodStates['formProd'] && !prodStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {prodStates['formProd']['competidores'].map((cp) => {
                                            return (
                                                <List.Item key={cp['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {cp['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador: {cp['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            })
                                        }
                                    </List> }

                                    {prodStates['formProd'] && !prodStates['isEditing']
                                        &&
                                        <Header as='h4' dividing>
                                            <Header.Content>
                                                Lojas
                                            </Header.Content>
                                        </Header>
                                    }
                                    {prodStates['formProd'] && !prodStates['isEditing'] && <List divided relaxed style={{marginTop: '30px'}}>
                                        {prodStates['formProd']['lojas'].map((loja) => {
                                            return (
                                                <List.Item key={loja['id']}>
                                                    <List.Content>
                                                        <List.Header style={{fontSize: '13px'}}>
                                                            {loja['nome']}
                                                        </List.Header>
                                                        <List.Description style={{fontSize: '12px'}}>Identificador: {loja['id']}</List.Description>
                                                    </List.Content>
                                                </List.Item>
                                                )
                                            }
                                        )
                                    }
                                    </List> }

                                    <Form.Group>
                                        {prodStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            primary
                                            type='submit'
                                            size="mini"
                                            floated='right'
                                            onClick={handlePut}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='save'/> Salvar
                                                </div>
                                        </Button>}
                                        {prodStates['isEditing'] && <Button
                                            style={{marginLeft: '7px', marginTop: '7px'}}
                                            color='red'
                                            size="mini"
                                            floated='right'
                                            onClick={cancelProdEdit}
                                            >
                                                <div style={{ verticalAlign: 'middle', width: '70px', fontSize: '10px'}}>
                                                    <Icon name='cancel'/> Cancelar
                                                </div>
                                        </Button>}
                                    </Form.Group>
                                </Form>
                        </Segment>
                    </div>
                </Content>
                <Footer></Footer>
            </Container>
        </Container>
    );
}
